function AlarmRuleController($uibModal, userService, toasterService) {
  const ctrl = this;

  ctrl.onView = rule => {
    if (!userService.hasAccessAlarms()) {
      toasterService.error('forbidden-error.title', 'forbidden-error.message');
      return;
    }
    $uibModal.open({
      component: 'alarmRuleViewDialog',
      windowClass: 'alarm-rule-view-modal-window',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        rule: () => rule,
      },
    });
  };

  ctrl.onEdit = rule => {
    if (!userService.hasAccessAlarms()) {
      toasterService.error('forbidden-error.title', 'forbidden-error.message');
      return false;
    }
    return $uibModal
      .open({
        component: 'alarmRuleEditDialog',
        windowClass: 'alarm-rule-view-modal-window',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          rule: () => rule,
        },
      })
      .result.then(() => true, () => false);
  };

  ctrl.onRunReport = rule => {
    if (!userService.hasAccessAlarms()) {
      toasterService.error('forbidden-error.title', 'forbidden-error.message');
      return;
    }
    $uibModal.open({
      component: 'alarmRuleReportDialog',
      windowClass: 'alarm-rule-view-modal-window',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        rule: () => rule,
      },
    });
  };
}

angular
  .module('analysis.module')
  .controller('AlarmRuleController', AlarmRuleController);
